
import HeaderLayout from "@/components/layouts/Header.vue";
import FooterLayout from "@/components/layouts/Footer.vue";
import QuadrupleBlock from "@/components/blocks/Quadruple.vue";
import TripleBlock from "@/components/blocks/Triple.vue";

export default {
  name: "NieuwsView",
  components: {
    TripleBlock,
    HeaderLayout,
    FooterLayout,
  },
};
